import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToNumber } from "@tsp-core/utils/number";

import { GeneralLedgerAccountCode } from "../types";

export function parseGeneralLedgerAccountCode<Input extends unknown>(
  input: Input,
): Input extends GeneralLedgerAccountCode ? GeneralLedgerAccountCode : GeneralLedgerAccountCode | null {
  const code = parseUnknownToNumber(input, "integer");
  if (checkIsNotNullish(code)) {
    return code as GeneralLedgerAccountCode;
  }

  return null as any;
}
